module.exports = "<!-- Basic Information\r\n================================================= -->\r\n<div id=\"cell-videoconference\" style=\"background-color:white;height: 50vh;overflow-y: auto;\">\r\n\r\n</div>\r\n"


//////////////////
// WEBPACK FOOTER
// C:/prj/liveplanet-app-site/src/app/components/+gameevent/cellphone-modal/videoconference-screen/videoconference-screen.html
// module id = ../../../../../src/app/components/+gameevent/cellphone-modal/videoconference-screen/videoconference-screen.html
// module chunks = main